import { Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";

const PreventiveView = ({ preventives }) => {
  const { clinicStocks } = useSelector((state) => state?.clinic);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  const getPreventiveByType = (typ) => {
    return (preventives ?? reqDet?.prevetive)?.filter(
      (pre) =>
        pre?.type?.toLowerCase() === "vaccines"
          ? "vaccination"
          : pre?.type?.toLowerCase() === typ
      // && pre?.status === "Completed"
    );
  };

  const getBatchDetail = (stockId, batchId) => {
    if (!stockId && !batchId) return null;
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    const filteredBatches = reqStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return filteredBatches;
  };

  const renderRecord = (list) => {
    return list?.map((li, i) => {
      const batchDet = getBatchDetail(li?.stockId, li?.batchId) ?? null;

      return (
        <div className="gray-back-con1 mv5" key={Date.now() + i}>
          <div className="flex-row-ali-cen flex-row-wrap">
            <Typography className="txt-semi-bold black fs12">
              Product Name: {li?.name}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Batch No:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {batchDet?.batchNo ?? ""}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Mfg Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.mfgDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Exp Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.expiryDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt5 flex-row-wrap">
            <div className="gray-dot2 mr5" />
            <Typography className="font-medium black4 fs12">
              Administered date & by:
            </Typography>
            <div className="flex-row">
              <Typography className="txt-regular black4 fs12 ml5 capitalize">
                {moment(new Date(li?.date)).format("DD MMM YYYY")}
              </Typography>
              {li?.doctorName?.length > 0 ? (
                <div className="flex-row">
                  <div className="txt-regular black4 fs12 ml5 capitalize">
                    | {li?.doctorId === li?.clinicId ? "" : "Dr. "}
                    {li?.doctorName}
                  </div>
                  {li?.registrationNo?.length > 0 ? (
                    <div className="flex-row-ali-cen">
                      <div className="font-regular fs12 black ml5">(</div>
                      <div className="font-medium black4 fs12 ml2">RegNo:</div>
                      <div className="font-regular fs12 black ml5 capitalize">
                        {li?.registrationNo} )
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      {getPreventiveByType("vaccination")?.length > 0 && (
        <>
          <Typography className="font-bold blue-color fs14 mv5">
            Vaccination
          </Typography>
          {renderRecord(getPreventiveByType("vaccination"))}
        </>
      )}
      {getPreventiveByType("deworming")?.length > 0 && (
        <>
          <Typography className="font-bold blue-color fs14 mv5">
            Deworming
          </Typography>
          {renderRecord(getPreventiveByType("deworming"))}
        </>
      )}
      {getPreventiveByType("fleatreatment")?.length > 0 && (
        <>
          <Typography className="font-bold blue-color fs14 mv5">
            Flea Treatment
          </Typography>
          {renderRecord(getPreventiveByType("fleatreatment"))}
        </>
      )}
    </div>
  );
};

export default PreventiveView;
